import { extend } from 'vee-validate';
import { required, email, confirmed } from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

setInteractionMode('lazy');

extend('confirmed', {
  ...confirmed,
  message: 'Passwords don\'t match',
});

extend('email', {
  ...email,
  message: 'Please enter a valid e-mail',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

extend('phoneNumber', {
  message: () => `Please follow the format ###-###-####`,
  validate (value) {
    // eslint-disable-next-line no-useless-escape
    // return /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g.test(value);
    return /^\d{3}-\d{3}-\d{4}$/g.test(value);
  },
});

extend('currency', {
  message: () => `This field does not have a  valid format ###,###.##, please use commas and decimals`,
  validate (value) {
    return  /^\$?(([1-9]\d{0,2}(,\d{3})*)|0)?\.\d{1,2}$/.test(value);
  },
});

extend('decimal', {
  message: () => `This field does not have a  valid format ###.##`,
  validate (value) {
    return  /^[0-9]+(\.[0-9][0-9]?)?$/.test(value);
  },
});

extend('zipCode', {
  message: () => `Please enter a valid zip code`,
  validate (value) {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
  },
});

extend('percentage', {
  message: () => `Please use the following amount format ###.##`,
  validate(value) {
    return /^(?!0[0-9])\d{1,3}(\.\d{1,3})?%?$/.test(value);
  },
});

extend('phlpass', {
  message: () => `Your password does not meet the requirements.`,
  validate(value) {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})/.test(value);
  },
});

/**
 * Custom validations
 */
// const phoneNumber = {
//   getMessage: field => `${field} is not a valid phone number`,
//   validate (value) {
//     // eslint-disable-next-line no-useless-escape
//     // return /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g.test(value);
//     return /^\d{3}-\d{3}-\d{4}$/g.test(value);
//   },
// };
// VeeValidate.Validator.extend('phoneNumber', phoneNumber);

// const currency = {
//   getMessage: field => `${field} is not in a valid currency format ###,###.##, please use commas and decimals`,
//   validate (value) {
//     return  /^\$?(([1-9]\d{0,2}(,\d{3})*)|0)?\.\d{1,2}$/.test(value);
//   },
// };
// VeeValidate.Validator.extend('currency', currency);

// const zipCode = {
//   getMessage: () => `Please enter a valid zip code`,
//   validate (value) {
//     return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
//   },
// };
// VeeValidate.Validator.extend('zipCode', zipCode);

// const percentage = {
//   getMessage: () => `Please use the following amount format ###.##`,
//   validate(value) {
//     return /^(?!0[0-9])\d{1,3}(\.\d{1,3})?%?$/.test(value);
//   },
// };

// VeeValidate.Validator.extend('percentage', percentage);

// const phlpass = {
//   getMessage: () => `Your password does not meet the requirements.`,
//   validate(value) {
//     return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})/.test(value);
//   },
// };

// VeeValidate.Validator.extend('phlpass', phlpass);
